(function($) {

    jQuery('.delete-btn').click(function () {
      var deleteid = jQuery(this).data("id");
        console.log(deleteid );
        var dataObj = {
            'action': 'delete_lead',
            'id': deleteid
        };
      jQuery.ajax({
        url: ajaxurl,
        data: dataObj,
        success: function(response) {
            console.log(response);
            if(response == "1"){
               location.reload();
            }
        },
        error: function(errorThrown) {
            console.log(errorThrown);
        }
    });
    });

  })( jQuery );